// extracted by mini-css-extract-plugin
export default {"sendMessageButton":"TalentPreviewHeader_sendMessageButton__UUeaA"};